import Skeleton from "@/components/shared/skeleton";

import styles from "../../index.module.scss";

/* ローディング中表示用 */
const VenuetypeSkeleton: React.FC = () => {
  return (
    <div
      className={`${styles.skeleton_height} mx-[2.5%] mb-44 w-[45%] space-y-12`}
    >
      <Skeleton className="h-full w-full rounded-2xl" />
      <Skeleton className="h-[2rem] w-1/2" />
    </div>
  );
};

export default VenuetypeSkeleton;
